import { productImageTransform } from '@utils/transformations/product-image-transformation';

export const productDetailTransform = product => ({
  images: product['images'].map(productImageTransform),
  productName: product['product_name'],
  skuCode: product['sku_code'],
  description: product['description'],
  feature: product['feature'],
});
